import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import featureService from "./featureService"; // Assuming the service file is appropriately updated

export const getFeatures = createAsyncThunk(
  "feature/get-features",
  async (thunkAPI) => {
    try {
      return await featureService.getFeatures();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getAFeature = createAsyncThunk(
  "feature/get-feature",
  async (id, thunkAPI) => {
    try {
      return await featureService.getFeature(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createFeature = createAsyncThunk(
  "feature/create-feature",
  async (featureData, thunkAPI) => {
    try {
      return await featureService.createFeature(featureData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAFeature = createAsyncThunk(
  "feature/update-feature",
  async (feature, thunkAPI) => {
    try {
      return await featureService.updateFeature(feature);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAFeature = createAsyncThunk(
  "feature/delete-feature",
  async (id, thunkAPI) => {
    try {
      return await featureService.deleteFeature(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  features: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const featureSlice = createSlice({
  name: "features",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFeatures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFeatures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.features = action.payload;
      })
      .addCase(getFeatures.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createFeature.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createFeature.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdFeature = action.payload;
      })
      .addCase(createFeature.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAFeature.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAFeature.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.featureName = action.payload.title;
      })
      .addCase(getAFeature.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAFeature.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAFeature.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedFeature = action.payload;
      })
      .addCase(updateAFeature.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAFeature.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAFeature.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedFeature = action.payload;
      })
      .addCase(deleteAFeature.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default featureSlice.reducer;
